import React from 'react';
import { Link } from 'react-router-dom';
import { LogIn, ShoppingCart, UserPlus } from 'lucide-react';
import { useAuth } from '../contexts/UserContext';

const TopBarAuthButtons: React.FC = () => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return (
      <>
        <Link
          to="/login"
          className="flex items-center space-x-2 text-gray-700 hover:text-tennis-600 transition-colors duration-200"
        >
          <LogIn size={18} />
          <span className="hidden md:inline">登录</span>
        </Link>
        <Link
          to="/register"
          className="flex items-center space-x-2 text-gray-700 hover:text-tennis-600 transition-colors duration-200"
        >
          <UserPlus size={18} />
          <span className="hidden md:inline">注册</span>
        </Link>
      </>
    );
  }

  return (
    <Link
      to="/cart"
      className="flex items-center space-x-2 text-gray-700 hover:text-tennis-600 transition-colors duration-200"
    >
      <ShoppingCart size={18} />
      <span className="hidden md:inline">购物车</span>
    </Link>
  );
};

export default TopBarAuthButtons;
